import router from '@/router'

export const install = (app: any) => {
    app.use(router)
}
